export const SessionQueries = {
  ACTIVITY_ID: "Activity ID",
  CLAIM_ID: "Claim ID",
  PROVIDER_AND_CLIENT: "Provider and Client",
  INVOICE_STATUS: "Invoice Status"
};
